export default {
  name: 'ServidorMixin',
  inject: {
    erplayout: {
      default () {
        console.error('Main needs to be child of ErpLayout')
      }
    }
  },
  mounted() {
    window.setTimeout(() => {
      this.erplayout.erpheader.setMenuModuleToggle(true)
    }, 10)
    !document.body.classList.contains('gerencia-servidor-module-body') && document.body.classList.add('gerencia-servidor-module-body')
    this.erplayout.erpheader.menu.setActiveMenu('gerencia')
  },
  destroyed() {
    document.body.classList.remove('gerencia-servidor-module-body')
    // document.querySelector('.u-erp-layout-container').classList.remove('bg-white')
  },
  beforeDestroy() {
    this.erplayout.erpheader.setMenuModuleToggle(false)
  }
}
